module.exports = __webpack_public_path__ + "static/img/04-1.f41737f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market101/04-1.png
// module id = aLzy
// module chunks = 1